<form>
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.MainDashboard_UnassignedBikes }}</h2>
    </div>

    <div class="form-section-function">
        <div class="flex-col">
            <div class="flex-row">
                <app-multiple-search [searchFields]="unassignedFields" [searchByList]="searchByList" (searchByListChange)="onSearchChanged($event)">
                </app-multiple-search>
            </div>
            <div class="flex-row">
                <app-search-badge [searchByList]="searchByList" [listFields]="unassignedFields" (searchByListChange)="onSearchChanged($event)"></app-search-badge>
            </div>
        </div>
    </div>

    <div class="form-section table">
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col"
                    [ngClass]="{'clickable':unassignedField.GroupBy, 'bold':order==unassignedField.FieldName}"
                    *ngFor="let unassignedField of unassignedFields"
                    [hidden]="unassignedField.Hidden"
                    (click)="setOrder(unassignedField.FieldName, unassignedField.GroupBy)">
                    {{ unassignedField.DisplayName }}
                    <span class="order-icon" *ngIf="order==unassignedField.FieldName && !reverse">▼</span>
                    <span class="order-icon" *ngIf="order==unassignedField.FieldName && reverse">▲</span>
                </div>
            </div>
            <ng-scrollbar *ngIf="!loading" [orientation]="'vertical'">
                <div class="flex-row" *ngFor="let unassignedEl of unassignedBikeList | multipleSearchProperty : searchByList
                | orderBy: order: reverse
                | paginate: { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let index = index;">
                    <div class="flex-col" *ngFor="let unassignedField of unassignedFields" [hidden]="unassignedField.Hidden"
                    [ngClass]="{'uppercase': unassignedField.Uppercase}">
                        <span>
                            {{ unassignedEl[unassignedField.FieldName] }}
                        </span>
                    </div>
                </div>
                <div class="flex-row" *ngIf="unassignedBikeList.length==0 && !loading">
                    <div class="flex-col">{{ languageService.languageJSON.Global_NoItems }}</div>
                </div>
            </ng-scrollbar>
            <!-- paginator -->
            <app-loading-animation *ngIf="loading"></app-loading-animation>
        </div>
    </div>
    <div class="pagination" *ngIf="!loading">
        <div class="pagination-text">{{ getPaginationText() }}</div>
        <pagination-controls (pageChange)="onPageChangeEvent($event)"></pagination-controls>
    </div>
</form>